/** Native 3D / vendor geometry: Cadwork, SketchUp, Rhino, IFC, STEP, DXF, SAT (SIP/CAD interchange). */
export const THREE_D_RAW_NAME_RE = /\.(3d|skp|3dm|ifc|ifczip|step|stp|dxf|sat)$/i;

export const THREE_D_RAW_ACCEPT = '.3d,.skp,.3dm,.ifc,.ifczip,.step,.stp,.dxf,.sat';

export function isThreeDRawFile(file: Pick<File, 'name' | 'type'>): boolean {
  return THREE_D_RAW_NAME_RE.test(file.name || '');
}
